import React, { useEffect } from 'react';
import { Col, Container, Form, FormFeedback, Row } from 'reactstrap';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import {addMessage} from "../../../slices/message/add/thunk";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";

const Contact = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const contactForm = useFormik({
    enableReinitialize: false,
    initialValues: {
      name: '',
      email: '',
      message: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required(t("Please Enter Your Name"))
        .min(3, t('min.field.characters', { count: 3 }))
        .max(30, t("max.field.characters", { count: 30 })),
      email: Yup.string().required(t("Please Enter Your Email"))
        .min(3, t('min.field.characters', { count: 3 }))
        .max(40, t("max.field.characters", { count: 40 })),
      message: Yup.string().required(t("Please Enter Message"))
        .min(10, t('min.field.characters', { count: 10 }))
        .max(500, t("max.field.characters", { count: 500 })),
    }),
    onSubmit: (values) => {
      dispatch(addMessage(values));
    }
  });

  // MESSAGE ADD
  const selectAddMessage = createSelector(
    (state) => state.MessageAdd,
    (slice) => ({
      messageAddSuccess: slice.success,
      messageAddError: slice.error,
    })
  );
  const {
    messageAddError,
    messageAddSuccess,
  } = useSelector(selectAddMessage);

  useEffect(() => {
    if (messageAddSuccess) {
      contactForm.resetForm();
    }
  }, [messageAddSuccess]);

    return (
        <React.Fragment>
            <section className="section pt-4" id="contact" aria-labelledby="contact-heading">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h2 id="contact-heading" className="mb-3 fw-semibold">{t('landing.contact.title')}</h2>
                                <p className="text-muted mb-4 ff-secondary">
                                    {t('landing.contact.subtitle')}
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="gy-4">
                        <Col lg={4}>
                            <address>
                                <div className="mt-4">
                                    <h3 className="fs-13 text-muted text-uppercase">{t('landing.contact.companyAddress')}</h3>
                                    <div className="ff-secondary fw-semibold">
                                        T-code Tomasz Hliwiadczyn<br/>
                                        Immanuela Kanta 56/15<br />
                                        10-691 Olsztyn
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <h3 className="fs-13 text-muted text-uppercase">{t('landing.contact.contactDetails')}</h3>
                                    <div className="ff-secondary fw-semibold">
                                        <a href="tel:+48691932242" title={t('landing.contact.callUs')}>+48 691 932 242</a><br />
                                        <a href="mailto:tomasz.hliwiadczyn@gmail.com" title={t('landing.contact.emailUs')}>tomasz.hliwiadczyn@gmail.com</a>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <h3 className="fs-13 text-muted text-uppercase">{t('landing.contact.hours')}</h3>
                                    <div className="ff-secondary fw-semibold">
                                        <time>8:00 - 16:00</time>
                                    </div>
                                </div>
                            </address>
                        </Col>

                        <Col lg={8}>
                            <div>
                                <Form className="tablelist-form" onSubmit={(e) => {
                                  e.preventDefault();
                                  contactForm.handleSubmit();
                                }}>
                                    <Row>
                                      <Col lg={12}>
                                      {messageAddError &&
                                        <div className="alert alert-danger fs-13" role="alert">
                                          <strong>{t("Internal Server Error")}</strong>
                                        </div>
                                      }
                                        {messageAddSuccess &&
                                          <div className="alert alert-success fs-13" role="alert">
                                            <strong>{t("Message sent successfully")}</strong>
                                          </div>
                                        }
                                      </Col>
                                        <Col lg={6}>
                                          <div className="mb-4">
                                            <label htmlFor="name" className="form-label fs-13">{t('landing.contact.nameLabel')}</label>
                                            <input
                                              name="name"
                                              id="name"
                                              type="name"
                                              className={`form-control bg-light border-light ${contactForm.touched.name && contactForm.errors.name ? 'is-invalid' : ''}`}
                                              placeholder={t('landing.contact.namePlaceholder')}
                                              onChange={contactForm.handleChange}
                                              onBlur={contactForm.handleBlur}
                                              value={contactForm.values.name || ''}
                                            />
                                            {contactForm.touched.name && contactForm.errors.name ? (
                                              <FormFeedback type="invalid">{contactForm.errors.name}</FormFeedback>
                                            ) : null}
                                          </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-4">
                                                <label htmlFor="email" className="form-label fs-13">Email</label>
                                                <input
                                                  name="email"
                                                  id="email"
                                                  type="email"
                                                  onChange={contactForm.handleChange}
                                                  onBlur={contactForm.handleBlur}
                                                  value={contactForm.values.email || ''}
                                                  className={`form-control bg-light border-light ${contactForm.touched.email && contactForm.errors.email ? 'is-invalid' : ''}`}
                                                  placeholder={t('landing.contact.emailPlaceholder')} />
                                              {contactForm.touched.email && contactForm.errors.email ? (
                                                <FormFeedback type="invalid">{contactForm.errors.email}</FormFeedback>
                                              ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="mb-3">
                                                <label htmlFor="message" className="form-label fs-13">{t('landing.contact.messageLabel')}</label>
                                                <textarea
                                                  name="message"
                                                  id="message"
                                                  rows="6"
                                                  onChange={contactForm.handleChange}
                                                  onBlur={contactForm.handleBlur}
                                                  value={contactForm.values.message || ''}
                                                  className={`form-control bg-light border-light ${contactForm.touched.message && contactForm.errors.message ? 'is-invalid' : ''}`}
                                                    placeholder={t('landing.contact.messagePlaceholder')}></textarea>
                                              {contactForm.touched.message && contactForm.errors.message ? (
                                                <FormFeedback type="invalid">{contactForm.errors.message}</FormFeedback>
                                              ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12} className="text-end">
                                            <input type="submit" id="submit" name="send" className="submitBnt btn btn-primary"
                                                value={t('landing.contact.submit')} />
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Contact;
